export interface CandidateProfile {
  id: string
  name: string // Anonymisert
  title: string
  location: string
  experience: string
  availability: string
  description: string
  topSkills: string[]
  traits: string[]
  salary?: string
}

export const mockProfiles: CandidateProfile[] = [
  {
    id: '1',
    name: 'Kandidat #847',
    title: 'Senior Frontend Utvikler',
    location: 'Oslo',
    experience: '5 år',
    availability: 'Tilgjengelig nå',
    description: 'Erfaren frontend-utvikler med lidenskap for React og moderne webutvikling. Brenner for god brukeropplevelse og ren kode.',
    topSkills: ['React', 'TypeScript', 'Next.js', 'Tailwind'],
    traits: ['Resultatentert', 'Teamplayer'],
    salary: '700 000 - 850 000 kr'
  },
  {
    id: '2',
    name: 'Kandidat #523',
    title: 'Autorisert Rørlegger',
    location: 'Bergen',
    experience: '10+ år',
    availability: 'Om 2 uker',
    description: 'Fagbrev i VVS med lang erfaring fra både private og kommersielle prosjekter. Spesialist på baderomsrenovering.',
    topSkills: ['Fagbrev VVS', 'Baderomsprosjekter', 'Vedlikehold', 'Feilsøking'],
    traits: ['Pålitelig', 'Grundig'],
  },
  {
    id: '3',
    name: 'Kandidat #291',
    title: 'Snekker',
    location: 'Trondheim',
    experience: '15 år',
    availability: 'Tilgjengelig nå',
    description: 'Svennebrev som tømrer. Spesialisert på møbelsnekring og kjøkkeninnredning. Erfaring med både tradisjonelt og moderne håndverk.',
    topSkills: ['Tømrer fagbrev', 'Møbelsnekring', 'Kjøkken', 'Innredning'],
    traits: ['Kreativ', 'Kvalitetsbevisst']
  },
  {
    id: '4',
    name: 'Kandidat #756',
    title: 'Vaskehjelp / Rengjøring',
    location: 'Oslo',
    experience: '3 år',
    availability: 'Fleksibel',
    description: 'Erfaring med både privathjem og små kontorer. Pålitelig og grundig med gode referanser. Kan starte umiddelbart.',
    topSkills: ['Privathjem', 'Kontorbygg', 'Grundig', 'Miljøvennlig'],
    traits: ['Pålitelig', 'Punktlig']
  },
  {
    id: '5',
    name: 'Kandidat #412',
    title: 'Sykepleier',
    location: 'Stavanger',
    experience: '7 år',
    availability: 'Om 1 måned',
    description: 'Autorisert sykepleier med spesialisering i eldreomsorg. Erfaring fra både sykehjem og hjemmetjeneste.',
    topSkills: ['Autorisert', 'Eldreomsorg', 'Medisinering', 'Dokumentasjon'],
    traits: ['Empatisk', 'Ansvarsfull'],
    salary: '550 000 - 650 000 kr'
  },
  {
    id: '6',
    name: 'Kandidat #638',
    title: 'Servitør',
    location: 'Oslo',
    experience: '4 år',
    availability: 'Tilgjengelig nå',
    description: 'Erfaren servitør fra fine dining restauranter. God kjennskap til vin og servicebevisst. Tospråklig norsk/engelsk.',
    topSkills: ['Fine dining', 'Vinkunnskaper', 'Serviceinnstilt', 'Tospråklig'],
    traits: ['Serviceinnstilt', 'Positiv']
  },
  {
    id: '7',
    name: 'Kandidat #904',
    title: 'Elektriker',
    location: 'Drammen',
    experience: '8 år',
    availability: 'Om 3 uker',
    description: 'Autorisert elektriker med erfaring fra både bolig og næring. Sertifisert for høyspent og brannanlegg.',
    topSkills: ['Fagbrev elektriker', 'Høyspent', 'Brannanlegg', 'Feilsøking'],
    traits: ['Sikkerhetsbevisst', 'Nøyaktig'],
    salary: '600 000 - 750 000 kr'
  },
  {
    id: '8',
    name: 'Kandidat #267',
    title: 'Regnskapsfører',
    location: 'Bergen',
    experience: '6 år',
    availability: 'Tilgjengelig nå',
    description: 'Autorisert regnskapsfører med erfaring fra små og mellomstore bedrifter. God kjennskap til Tripletex og Poweroffice.',
    topSkills: ['Autorisert', 'Tripletex', 'Årsoppgjør', 'Merverdiavgift'],
    traits: ['Nøyaktig', 'Strukturert'],
    salary: '500 000 - 600 000 kr'
  },
  {
    id: '9',
    name: 'Kandidat #583',
    title: 'Backend Utvikler',
    location: 'Oslo',
    experience: '6 år',
    availability: 'Om 1 måned',
    description: 'Spesialisert på Python og microservices arkitektur. Erfaring med AWS, Docker og Kubernetes. Brenner for skalerbare løsninger.',
    topSkills: ['Python', 'FastAPI', 'AWS', 'Docker'],
    traits: ['Analytisk', 'Problemløser'],
    salary: '650 000 - 800 000 kr'
  },
  {
    id: '10',
    name: 'Kandidat #195',
    title: 'Resepsjonist',
    location: 'Trondheim',
    experience: '5 år',
    availability: 'Tilgjengelig nå',
    description: 'Erfaring fra hotellbransjen med førsteklasses kundeservice. Tospråklig norsk/engelsk, grunnleggende tysk.',
    topSkills: ['Kundeservice', 'Hotellsystemer', 'Tospråklig', 'Organisert'],
    traits: ['Vennlig', 'Profesjonell']
  }
]

